import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { DialogProps } from './types';

const useRestrictionSelectorStyles = makeStyles(({ spacing, palette }) => {
  return createStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      position: 'relative',
    },
    title: {
      flex: 1,
      position: 'relative',
      paddingRight: ({ document }: DialogProps) => (document ? spacing(8) : undefined),
    },
    documentButton: {
      position: 'absolute',
      right: 0,
    },
    headerButtons: {
      alignContent: 'center',
      paddingRight: ({ document }: DialogProps) => (document ? spacing(9) : undefined),
    },
    subtitle: {
      fontSize: 12,
      color: palette.text.secondary,
      paddingTop: 0,
      paddingLeft: spacing(6),
      paddingRight: spacing(6),
      marginTop: `-${spacing(4)}`,
    },
  });
});
export default useRestrictionSelectorStyles;
